<section>

  <div class="bl-margin-bottom--40">
    <!-- <h2 class="bl-font-size--32 bl-font-weight--900 bl-font-color--black bl-margin-bottom--0">
      {{page.customTitleOrDefault | titlecase }}</h2> -->

    <div class="dx-workflow-card bl-block-module">
      <ng-container *ngIf="page?.config?.reviewRendererType; else defaultTemplate">
        <cu-review-resolver [reviewComponentType]="page.config.reviewRendererType" [flow]="flow"
          [page]="page"></cu-review-resolver>
      </ng-container>
      <ng-template #defaultTemplate>
        <div *ngFor="let card of getReviewCards();let allowEdit = first">
          <ecp-review-card [card]="card" [flow]="flow" [page]="page" [editUrlFn]="editUrlFn" [allowEdit]="allowEdit">
          </ecp-review-card>
        </div>
      </ng-template>
    </div>
  </div>
</section>